import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

document.querySelectorAll('.slider-img--slider').forEach((el) => {
  const swiper = new Swiper(el, {
    modules: [Autoplay],
    slidesPerView: 1,
    loop: true,
    grabCursor: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });

  const container = el.closest('.slider-img--container');
  if (!container) return;

  const slides = el.querySelectorAll('.swiper-slide');
  if (slides.length <= 1) {
    container.querySelectorAll('.slider-img--arrow').forEach(a => a.style.display = 'none');
    swiper.autoplay.stop();
    return;
  }

  container.querySelector('.slider-img--arrow.next')?.addEventListener('click', () => swiper.slideNext());
  container.querySelector('.slider-img--arrow.prev')?.addEventListener('click', () => swiper.slidePrev());
});
